import { Button } from 'react-bootstrap'
import React from 'react'

export const BulkUpdateZeroCostView = (props) => {
    return <div>
        <div>
            <textarea onChange={(e) => props.onChangeText(e)} value={props.text}></textarea>
        </div>
        <Button onClick={props.onSubmit}>Submit</Button>
        {props.complete && 'Updated'}
    </div>
}